"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactRedirectWidget = exports.reactWidgetStateProcessor = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _sdk = require("@mid/sdk");

var consts = _interopRequireWildcard(require("./constants"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 *
 * @param {object} state - the react component state
 * @param {object} action - what to do next
 * @return {object} the next react state
 */
var reactWidgetStateProcessor = function reactWidgetStateProcessor(state, action) {
  switch (action.type) {
    case consts.UPDATE_EMAIL:
      {
        var email = action.payload.email;
        return _objectSpread(_objectSpread({}, state), {}, {
          email: email
        });
      }

    case consts.SUBMIT_EMAIL:
      {
        var _email = state.email,
            st = state.st; // eslint-disable-next-line no-new

        new Promise( /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(resolve) {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.t0 = resolve;
                    _context.next = 3;
                    return (0, _sdk.nextState)(st, new Map().set(_sdk.PHASE, _sdk.ST.EMAIL_ENTERED).set(_sdk.DATA, _email));

                  case 3:
                    _context.t1 = _context.sent;
                    (0, _context.t0)(_context.t1);

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        return state;
      }

    case consts.FOUND_TENANTS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          tenants: action.payload.tenants,
          resolver: action.payload.resolver
        });
      }

    case consts.SELECTED_TENANT:
      {
        var _action$payload = action.payload,
            tenant = _action$payload.tenant,
            resolver = _action$payload.resolver;
        var _st = state.st;
        resolver(tenant);
        return _objectSpread(_objectSpread({}, state), {}, {
          st: (0, _sdk.nextState)(_st, new Map().set(_sdk.PHASE, _sdk.ST.CONFIG_COMPLETE).set(_sdk.DATA, action.payload.tenant))
        });
      }

    case consts.LOGIN_CLICKED:
      {
        var _tenant = state.tenant,
            _email2 = state.email,
            mid = state.mid,
            _st2 = state.st;

        try {
          return mid.core.redirectLogin(_email2, _tenant).then(function () {
            return _objectSpread(_objectSpread({}, state), {}, {
              st: (0, _sdk.nextState)(_st2, new Map().set(_sdk.PHASE, _sdk.ST.LOGIN_REDIRECT))
            });
          }).catch(function (err) {
            return _objectSpread(_objectSpread({}, state), {}, {
              st: (0, _sdk.nextState)(_st2, new Map().set(_sdk.PHASE, _sdk.ST.FAIL).set(_sdk.ERROR_MSG, err.message))
            });
          });
        } catch (err) {
          return _objectSpread(_objectSpread({}, state), {}, {
            st: (0, _sdk.nextState)(_st2, new Map().set(_sdk.PHASE, _sdk.ST.FAIL).set(_sdk.ERROR_MSG, mid.errors.FAIL_RETR_METADATA('Failed to retrieve correct configuration information')).set(_sdk.DATA, {
              tenant: _tenant,
              email: _email2
            }))
          });
        }
      }

    default:
  }

  return state;
};

exports.reactWidgetStateProcessor = reactWidgetStateProcessor;

var multipleTenantResolver = function multipleTenantResolver(widget, st) {
  return function (resolve) {
    var endpoints = st.get(_sdk.DATA).endpoints;
    widget.tenants = endpoints;

    if (!endpoints || endpoints.length === 0) {
      resolve(st.set(_sdk.PHASE, _sdk.ST.NO_TENANT_FOUND));
    } else if (endpoints.length === 1) {
      widget.loginComponent.singleTenantSelect(endpoints[0]);
      resolve(st.set(_sdk.DATA, endpoints[0]).set(_sdk.PHASE, _sdk.ST.LOGIN));
    } else {
      widget.loginComponent.updateTenants({
        tenants: endpoints,
        tenantError: false,
        selectTenantResolver: function selectTenantResolver(tenant) {
          resolve(st.set(_sdk.DATA, tenant).set(_sdk.PHASE, _sdk.ST.LOGIN));
        }
      });
    }
  };
};

var tenantSelect = function (rf) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(widget, st) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              widget.loginComponent.updateTenants({
                tenantError: false
              });
              return _context2.abrupt("return", new Promise(rf(widget, st)));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}(multipleTenantResolver);

var noTenantFound = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(widget, st) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            widget.loginComponent.updateTenants({
              tenantError: true
            });
            return _context3.abrupt("return", st.set(_sdk.PHASE, _sdk.ST.START));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function noTenantFound(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

var onFail = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(widget, st) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            widget.loginComponent.setFailure(st.get(_sdk.ERROR_MSG)); // todo - this will soft-crash mid-sdk but will stop the state machine from progressing

            return _context4.abrupt("return", null);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function onFail(_x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();

var loginInfoFail = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(widget, st) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            widget.loginComponent.setFailure(st.get(_sdk.ERROR_MSG));
            return _context5.abrupt("return", null);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function loginInfoFail(_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();

var tenantFetch = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(widget, st) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", (0, _sdk.nextState)(st.set(_sdk.PHASE, _sdk.ST.START), st));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function tenantFetch(_x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Implements the React Redirect Login Widget
 * @type {LoginWidget}
 */


var ReactRedirectWidget = /*#__PURE__*/function () {
  function ReactRedirectWidget() {
    (0, _classCallCheck2.default)(this, ReactRedirectWidget);
    this.transition = this.transition.bind(this);
  }

  (0, _createClass2.default)(ReactRedirectWidget, [{
    key: "transition",
    value: function transition(st) {
      try {
        switch (st.get(_sdk.PHASE)) {
          case _sdk.ST.TENANT_FETCH:
            return tenantFetch(this, st);

          case _sdk.ST.TENANT_SELECT:
            return tenantSelect(this, st);

          case _sdk.ST.NO_TENANT_FOUND:
            return noTenantFound(this, st);

          case _sdk.ST.LOGIN_INFO_FAIL:
            return loginInfoFail(this, st);

          case _sdk.ST.FAIL:
            return onFail(this, st);

          case _sdk.ST.CONFIG_COMPLETE:
            return this._loginComponent.state.mid.core.redirectLogin(this._loginComponent.state.email, st.get(_sdk.DATA)).then(function () {
              return st.set(_sdk.PHASE, _sdk.ST.LOGIN_REDIRECT);
            }).catch(function (err) {
              return st.set(_sdk.PHASE, _sdk.ST.FAIL).set(_sdk.ERROR_MSG, err.message);
            });
        }

        return st;
      } catch (err) {
        return st.set(_sdk.PHASE, _sdk.ST.FAIL).set(_sdk.ERROR_MSG, err.messsage);
      }
    }
  }, {
    key: "tenants",
    set: function set(tenants) {
      this._tenants = tenants;
    }
  }, {
    key: "loginComponent",
    set: function set(c) {
      this._loginComponent = c;
    },
    get: function get() {
      return this._loginComponent;
    }
  }, {
    key: "tenantSelectorComponent",
    set: function set(c) {
      this._tenantSelectorComponent = c;
    },
    get: function get() {
      return this._tenantSelectorComponent;
    }
  }, {
    key: "loginButtonComponent",
    set: function set(c) {
      this._loginButtonComponent = c;
    },
    get: function get() {
      return this._loginButtonComponent;
    }
  }]);
  return ReactRedirectWidget;
}();

exports.ReactRedirectWidget = ReactRedirectWidget;